export enum BbxColumnType {
    TEXT,
    MONEY,
    DATE,
    MESSAGE,

}